export const normalizeTag = (raw: string): string =>
  raw.trim().replace(/^#+/, "").trim().toLowerCase();

/**
 * If `value` is a '#'-prefixed token followed by a separator (space or a
 * second '#'), return the token to commit and the remaining input to keep.
 * The separator itself is dropped; a following '#' is preserved as the start
 * of the next token. Returns null when there is nothing to auto-commit.
 */
export const parseHashtagInput = (
  value: string
): { commit: string; nextInput: string } | null => {
  if (!value.startsWith("#")) return null;
  const rest = value.slice(1);
  const sep = rest.match(/[\s#]/);
  if (!sep || sep.index === undefined) return null;
  const commit = rest.slice(0, sep.index);
  const remainder = value.slice(1 + sep.index);
  return { commit, nextInput: remainder.startsWith("#") ? remainder : "" };
};

export const availableSuggestions = (
  suggestions: string[],
  tags: { tag: string }[]
): string[] => suggestions.filter((s) => !tags.some((t) => t.tag === s));
